import { render, staticRenderFns } from "./ContentProviders.vue?vue&type=template&id=241f0cf6&"
import script from "./ContentProviders.vue?vue&type=script&lang=js&"
export * from "./ContentProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports